import React from 'react'
import { USER_PLACEHOLDER } from 'modules/users/consts'
import { UserNode } from 'modules/users/types.graphql'

export const UserContext = React.createContext<UserNode>(USER_PLACEHOLDER)
